<form [formGroup]="form">
  <mat-card *ngIf="data">
    <mat-card-title>Edit list</mat-card-title>
    <mat-card-content>
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" type="text" required />
        <mat-error *ngIf="form.get('name').hasError('required')">
          The name field is required.
        </mat-error>
      </mat-form-field>
      <app-list-data formControlName='data'></app-list-data>
    </mat-card-content>
    <mat-card-actions>
      <button (click)="onSubmit()" mat-raised-button color="primary">
        Save changes
      </button>
      <button (click)="onDelete()" mat-raised-button color="warn">
        Delete list
      </button>
      <a [routerLink]="['/list']" mat-flat-button color="link">
        Cancel
      </a>
    </mat-card-actions>
  </mat-card>
  <mat-spinner *ngIf="!data"></mat-spinner>
</form>
